import {AnyAction} from 'redux';

/* tslint:disable:ter-indent */
export const ERROR_GENERAL_ACTION = {
    name: 'ERROR_GENERAL_ACTION',
    action: (apiError: any, retryAction: AnyAction = null, url = '', body = {}, method = '',
             unexpectedErrors = []) => ({
        apiError,
        retryAction,
        url,
        method,
        body,
        unexpectedErrors,
        type: ERROR_GENERAL_ACTION.name
    })
};

export const IS_LOADING_ACTION = {
    name: 'IS_LOADING_ACTION',
    action: payload => ({
        payload,
        type: IS_LOADING_ACTION.name
    })
};
export const IS_LOADED_ACTION = {
    name: 'IS_LOADED_ACTION',
    action: payload => ({
        payload,
        type: IS_LOADED_ACTION.name
    })
};

export const INIT_APP_ACTION = {
    name: 'INIT_APP_ACTION',
    action: country => ({
        country,
        type: INIT_APP_ACTION.name
    })
};

export const ON_SELECT_STEP_ACTION = {
    name: 'ON_SELECT_STEP_ACTION',
    action: (step, highestStep, shouldRedirect = false) => ({
        step, highestStep, shouldRedirect,
        type: ON_SELECT_STEP_ACTION.name
    })
};

export const ON_SELECTED_STEP_ACTION = {
    name: 'ON_SELECTED_STEP_ACTION',
    action: (step, highestStep, shouldRedirect = false) => ({
        step, highestStep, shouldRedirect,
        type: ON_SELECTED_STEP_ACTION.name
    })
};

export const CLEAN_STATE_ACTION = {
    name: 'CLEAN_STATE_ACTION',
    action: () => ({
        type: CLEAN_STATE_ACTION.name
    })
};